<template>
<v-layout column>
    <v-form v-model="formValid" v-on:submit.prevent>
    <v-card flat>
        <v-toolbar dense color="shrink grey darken-1" card class="white--text">
            <v-toolbar-title>
                Teams
            </v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-btn :disabled="!pieceRateAgreementTeamsSelected" @click="showConfirmResendAgreementDialog(pieceRateAgreementSentTeamsSelected)" :loading="sendingAgreements">
                Send <v-icon right>email</v-icon>
            </v-btn>
        </v-toolbar>

        <v-alert class="ma-0"
            v-if="agreementSendResult.display"
            :value="agreementSendResult.message" 
            :type="agreementSendResult.success ? 'success' : 'error'" 
            dismissable>
            <v-layout>
            <v-flex grow>
                <span>{{ agreementSendResult.message }}</span>
            </v-flex>
            <v-flex shrink>
                <v-btn icon small class="ma-0"><v-icon @click="dismissPiecerateNotification()">close</v-icon></v-btn>
            </v-flex>
            </v-layout>
        </v-alert>
    </v-card> 
    <v-card v-if="harvestPlan">
        <v-expansion-panel v-model="panel" focusable expand>
            <v-expansion-panel-content v-for="(item, i) in getTeams" :key="i" lazy class="white--text" style="background:#449144">
                <template v-slot:header>
                    <v-flex shrink>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-checkbox v-model="item.SendPieceRateAgreement" hide-details class="shrink ma-0" @click="selectTeamPieceRateEmail($event, item)" v-on="on"></v-checkbox> 
                            </template>
                            <span v-if="item.PieceRateAgreementSent">
                                Sent by {{item.PieceRateAgreementSendByName}} at {{item.PieceRateAgreementSendTime | formatDateTimeToLocal}}
                            </span>
                            <span v-else>Agreement not sent</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex grow>
                        {{ item.TeamName }}
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-if="isSupervisorAllowanceApplied(item)" class="pl-1" color="red" v-on="on">supervisor_account</v-icon> 
                            </template>
                            <span>
                                Supervisor Allowance
                            </span>
                        </v-tooltip>
                    </v-flex>
                </template>
                <template v-slot:actions>
                    <v-icon color="white">$vuetify.icons.expand</v-icon>
                </template>
                <v-card>                    
                    <v-layout row wrap pa-2>
                        <v-flex xs12>
                            <v-alert type="warning" outline :value="isPastMidnight(item.BerriesHarvestPlanTeamID)">Warning - Estimated Finish Time extends after midnight.</v-alert>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Volume'" :value="`${formatVolume(getTeamVolume(item.BerriesHarvestPlanTeamID)) || 'N/A'} ${selectedUOM == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID ? '(Kgs)' : '(Trays)'}`"></label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'ICA'" :value="`${formatVolume(getTeamICAVolume(item.BerriesHarvestPlanTeamID)) || 'N/A'} ${selectedUOM == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID ? '(Kgs)' : '(Trays)'}`"></label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Pick Rate'" :value="`${getTeamPickRate(item.BerriesHarvestPlanTeamID)} ${selectedUOM == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID ? '(Derived Kgs/Hr)' : '(Derived Pun/Hr)'}`"></label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Start Time'" @edit="startTimeStartEdit" :value="item.StartTime" :editable="!isPast" :editOnEnter="!isPast">
                                <template v-slot:edit="{ commit }">        
                                    <v-menu v-model="showStartTimeMenu" @input="startTimeMenuInput(commit, item)" transition="scale-transition" offset-x :close-on-content-click="false">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                label="Start Time"
                                                ref="startTime"
                                                outline
                                                :loading="loading"    
                                                @click:append="startTimeAppendClicked"                         
                                                append-icon="timer"
                                                @focus="$event.target.select()"
                                                @keydown.enter="submit(commit, () => updateTeamStartTime(item), item.BerriesHarvestPlanTeamID)"
                                                @keydown.esc="submit(commit, () => updateTeamStartTime(item), item.BerriesHarvestPlanTeamID)"
                                                :value="item.StartTime"
                                                @input="startTimeInput(item, $event)"
                                                v-on="on" 
                                            >                                    
                                            </v-text-field>
                                        </template>
                                        <v-list>
                                            <v-layout wrap style="max-width:300px"> 
                                                <v-flex xs3 v-for="(time, index) in startTimes" :key="index" @click="startTimeClicked(commit, item, time)">
                                                    <v-list-tile style="cursor:pointer">
                                                        <v-list-tile-title>{{ time }}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-flex>
                                            </v-layout> 
                                        </v-list>                           
                                    </v-menu>
                                </template>
                            </label-value>     
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Est. Finish Time'" @edit="finishTimeStartEdit" :value="getFormatedFinishTime(getTeamFinishTime(item.BerriesHarvestPlanTeamID))" :editable="!isPast" :editOnEnter="!isPast" :prependIcon="true">
                                <template v-slot:prependIcon="{ commit }">
                                    <v-icon class="pl-1" title="recalculate" @click="submit(commit, () => { item.EndTime = null }, item.BerriesHarvestPlanTeamID)">replay</v-icon>
                                </template>
                                <template v-slot:edit="{ commit }">        
                                    <v-menu v-model="showFinishTimeMenu" @input="finishTimeMenuInput(commit, item)" transition="scale-transition" offset-x close-delay="100" :close-on-content-click="false">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                ref="estFinishTime"
                                                label="Est. Finish Time"
                                                outline
                                                :loading="loading"    
                                                @focus="$event.target.select()"
                                                @click:prepend="finishTimeAppendClicked"                         
                                                prepend-icon="access_time"
                                                @keydown.enter="submit(commit, () => { item.EndTime = item.EndTimeEdit !== undefined ? item.EndTimeEdit : item.EndTime }, item.BerriesHarvestPlanTeamID)"
                                                @keydown.esc="submit(commit, () => { item.EndTime = item.EndTimeEdit !== undefined ? item.EndTimeEdit : item.EndTime }, item.BerriesHarvestPlanTeamID)"
                                                :value="getFormatedFinishTime(getTeamFinishTime(item.BerriesHarvestPlanTeamID))"
                                                @input="finishTimeInput(item, $event)"
                                                v-on="on" 
                                            >                                    
                                            </v-text-field>
                                        </template>
                                        <v-list>
                                            <v-layout wrap style="max-width:300px"> 
                                                <v-flex xs3 v-for="(time, index) in finishTimes" :key="index" @click="finishTimeClicked(commit, item, time)">
                                                    <v-list-tile style="cursor:pointer">
                                                        <v-list-tile-title>{{time}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-flex>
                                            </v-layout> 
                                        </v-list>                           
                                    </v-menu>
                                </template>
                            </label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Supervisors'" :value="item.Supervisors" :editable="!isPast" :editOnFocus="!isPast">
                                <template v-slot:edit="{ commit }">
                                    <v-text-field
                                    label="Supervisors"
                                    :rules="[integer]"                                    
                                    outline
                                    type="number"
                                    autofocus
                                    :loading="loading"                               
                                    @blur="submit(commit, null, item.BerriesHarvestPlanTeamID)"
                                    @keydown.enter="handleEnter(commit)"
                                    @keydown.esc="handleEsc(commit)"
                                    v-model="item.Supervisors"
                                    >                                     
                                    </v-text-field>
                                </template>
                            </label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Assistants'" :value="item.Assistants" :editable="!isPast" :editOnFocus="!isPast">
                                <template v-slot:edit="{ commit }">
                                    <v-text-field
                                    label="Assistants"
                                    :rules="[integer]"                                    
                                    outline
                                    type="number"
                                    autofocus
                                    :loading="loading"                               
                                    @blur="submit(commit, null, item.BerriesHarvestPlanTeamID)"
                                    @keydown.enter="handleEnter(commit)"
                                    @keydown.esc="handleEsc(commit)"
                                    v-model="item.Assistants"
                                    >                                     
                                    </v-text-field>
                                </template>
                            </label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Picker Staff'" :value="item.PickerStaff" :editable="!isPast" :editOnFocus="!isPast">
                                <template v-slot:edit="{ commit }">
                                    <v-text-field
                                    label="Picker Staff"
                                    :rules="[integer]"                                    
                                    outline
                                    type="number"
                                    autofocus
                                    :loading="loading"                               
                                    @blur="submit(commit, null, item.BerriesHarvestPlanTeamID)"
                                    @keydown.enter="handleEnter(commit)"
                                    @keydown.esc="handleEsc(commit)"
                                    v-model="item.PickerStaff"
                                    >                                     
                                    </v-text-field>
                                </template>
                            </label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="'Piece Rate'" :value="`${getCurrencySymbol}${getTeamPieceRate(item.BerriesHarvestPlanTeamID)}`"></label-value>
                        </v-flex>
                        <v-flex>
                            <label-value :label="`Cost ${getCurrencySymbol}/Kg`" :value="`${getCurrencySymbol}${costPerKg(item.BerriesHarvestPlanTeamID)}`"></label-value>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-card>
                    <v-layout column pa-2>
                        <v-flex shrink>
                            <v-divider/>
                        </v-flex>
                        <v-flex>
                            <HarvestPlanTeamTable :berriesHarvestPlanTeamID="item.BerriesHarvestPlanTeamID" @changePayStyle="changePayStyle" ></HarvestPlanTeamTable>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <confirm-dialog :DisplayDialog="showConfirmEmail" :Loading="confirmDialogLoading" :DialogTitle="'Confirm to re-send Piece Rate Agreement'" :DialogContents="'This is a re-send for one of more of the selected Teams. Are you sure you want to proceed?'" @No="showConfirmEmail = false" @Yes="confirmResendAgreements"></confirm-dialog>
    </v-card>
    </v-form>
</v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import LabelValue from '@/components/generic/LabelValue.vue';
import HarvestPlanTeamTable from '@/components/harvestPlan/HarvestPlanTeamTable.vue'
import ConfirmDialog from '@/components/generic/YesNoPopup.vue';
import validationRules from "@/helpers/validationrules";
import UtilService from '@/services/utilService.js';
import moment from 'moment';
import * as Constants from "@/helpers/constants";

export default {
    components: {
        LabelValue,
        HarvestPlanTeamTable,
        ConfirmDialog
    },
    data() {
        return{
            focusElement: null,
            timeDialog: true,
            moment,
            loading: false,            
            rules: validationRules.rules,
            formValid: true,
            panel: [],
            showConfirmEmail: false,
            confirmDialogLoading: false,
            showFinishTimeMenu: false,
            showStartTimeMenu: false,
            startTimes: [
               "5:00",
               "5:15",
               "5:30",
               "5:45",
               "6:00",
               "6:15",
               "6:30",
               "6:45",
               "7:00",
               "7:15",
               "7:30",
               "7:45",
               "8:00",
               "8:15",
               "8:30",
               "8:45",
               "9:00",
               "9:15",
               "9:30",
               "9:45",
               "10:00",
               "10:15",
               "10:30",
               "10:45",
               "11:00",
               "11:15",
               "11:30",
               "11:45",
               "12:00"
            ],
            finishTimes: [
               "0:00",
               "1:00",
               "2:00",
               "3:00",
               "4:00",
               "5:00",
               "6:00",
               "7:00",
               "8:00",
               "9:00",
               "10:00",
               "11:00",
               "12:00",
               "13:00",
               "14:00",
               "15:00",
               "16:00",
               "17:00",
               "18:00",
               "19:00",
               "20:00",
               "21:00",
               "22:00",
               "23:00",
            ]
        }
    },
    computed: {
        ...mapState("HarvestPlanStore", [
            "harvestPlan",
            "sendingAgreements",
            "agreementSendResult",
            "plantData"
        ]),
        ...mapGetters("HarvestPlanStore", [
            "getTeamVolume",
            "getTeamICAVolume",
            "getTeamPickRate",
            "getTeamPieceRate",
            "getTeamCost",
            "getTeamVolumeKg",
            "getTeamStartTime",
            "getTeamEstimatedFinishTime",
            "getTeamFinishTime",
            "getTeams",
            "isPast",
            "selectedUOM"
        ]),
        getCurrencySymbol() {
            var selectedPlantData = this.plantData.find(x => x.PlantID == this.harvestPlan.PlantID)

            if(Constants.COMPANIES.CHINA.CompanyID == selectedPlantData.CompanyID){
                return '¥'
            }
            return '$'
        },
        //has the user selected one or more teams to send the piece rate agreement to
        pieceRateAgreementTeamsSelected(){
            var selected = this.harvestPlan.Teams.filter(t => t.SendPieceRateAgreement )
            return selected.length > 0;
        },
        //have any of the selected teams already been sent the agreement
        pieceRateAgreementSentTeamsSelected(){
            var selected = this.harvestPlan.Teams.filter(t => t.SendPieceRateAgreement && t.PieceRateAgreementSent )
            return selected.length > 0;
        }
    },
    watch: {
        timeDialog(val) {
            if (val) {
                document.addEventListener('mousedown', this.mousedownHandler);
            } else {
                document.removeEventListener('mousedown', this.mousedownHandler);
            }       
        },
        showFinishTimeMenu(val) {
            if(val) {
                if(this.$refs && this.$refs.estFinishTime && this.$refs.estFinishTime[0]) {
                    this.$refs.estFinishTime[0].focus();
                }
            }
        },
        showStartTimeMenu(val) {
            if(val) {
                if(this.$refs && this.$refs.startTime && this.$refs.startTime[0]) {
                    this.$refs.startTime[0].focus();
                }
            }
        }
    },
    methods: {
        ...mapActions("HarvestPlanStore", [
            "updateHarvestPlanTeam",
            "updateTeamPayStyle",
            "updateTeamStartTime",
            "sendSelectedTeamsPieceRateAgreement",
            "dismissPiecerateAgreementNotification"
        ]),
        mousedownHandler(e) {
            console.log(e.target.classList);
            if (e.target.classList.contains('v-overlay--active')) this.timeDialog = true;
        },
        isSupervisorAllowanceApplied(team) {
            return (team.Supervisors || 0) == 1 && (team.PickerStaff || 0) + (team.Assistants || 0) >= 50;
        },
        isPastMidnight(berriesHarvestPlanTeamID) {
            let start = this.getTeamStartTime(berriesHarvestPlanTeamID);
            let end = this.getTeamFinishTime(berriesHarvestPlanTeamID);

            if (start && end) {
                return end.date() > start.date();
            }

            return false;
        },
        isEstimatedFinishTime(berriesHarvestPlanTeamID) {
            let isEstimated = this.getTeamFinishTime(berriesHarvestPlanTeamID)
            return isEstimated
        },
        getFormatedFinishTime(v) {
            if (v) {                
                return v.format("HH:mm");
            }

            return null;
        },
        updateStartTime(item, value) {
            item.StartTime = value;
        },
        integer(v){            
            if (!v || v === "") {
                return true;
            }

            if(!v.toString().match(/^[0-9]{1,15}$/)){
                return "Please enter a whole positive number";
            }

            return false;
        },
        formatVolume(v) {            
            if (v) {
                return UtilService.thousandsSeparators(v);
            }

            return null;
        },
        costPerKg(berriesHarvestPlanTeamID) {
            return this.formatVolume(Math.round(this.getTeamCost(berriesHarvestPlanTeamID) / this.getTeamVolumeKg(berriesHarvestPlanTeamID) * 100) / 100) || 'N/A';
        },
        async changePayStyle(value) {
            await this.updateTeamPayStyle(value)
        },
        async submit(commit, modify, berriesHarvestPlanTeamID) {
            this.showFinishTimeMenu = false;
            this.showStartTimeMenu = false;
            if (this.loading || !this.formValid) {
                return;
            }

            if (modify) {
                modify();
            }

            this.loading = true;

            await this.updateHarvestPlanTeam(berriesHarvestPlanTeamID);
            commit();

            this.loading = false;
        },
        // fix bug -- enter/esc and blur will both be triggered
        handleEnter(commit) {
            commit();
        },
        handleEsc(commit) {
            commit();
        },
        finishTimeAppendClicked() {
            this.showFinishTimeMenu = !this.showFinishTimeMenu;
        },
        finishTimeInput(item, endTime) {
            if(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])$/.test(endTime)) {
                item.EndTimeEdit = endTime;
            } else if(/^([0-1]?[0-9]|2[0-4])?$/.test(endTime)) {
                item.EndTimeEdit = endTime + ':00';
            } else if(/^([0-1]?[0-9]|2[0-4]):?$/.test(endTime)) {
                item.EndTimeEdit = endTime + '00';
            } 
        },
        startTimeAppendClicked() {
            this.showStartTimeMenu = !this.showStartTimeMenu;
        },
        startTimeInput(item, startTime) {
            if(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])$/.test(startTime)) {
                item.StartTimeEdit = startTime;
            } else if(/^([0-1]?[0-9]|2[0-4])?$/.test(startTime)) {
                item.StartTimeEdit = startTime + ':00';
            } else if(/^([0-1]?[0-9]|2[0-4]):?$/.test(startTime)) {
                item.StartTimeEdit = startTime + '00';
            } 
        },
        async finishTimeClicked(commit, item, time) {
            item.EndTimeEdit = time; 
            await this.submit(commit, () => {   
            item.EndTime = item.EndTimeEdit !== undefined ? item.EndTimeEdit : item.EndTime;
            }, item.BerriesHarvestPlanTeamID);
        },
        async startTimeClicked(commit, item, time) {
            item.StartTimeEdit = time; 
            await this.submit(commit, () => {   
                this.updateTeamStartTime(item);
            }, -1);
        },
        finishTimeStartEdit() {
            this.$nextTick(() => {
                this.showFinishTimeMenu = true
            })
        },
        async finishTimeMenuInput(commit, item) {
            if(!this.showFinishTimeMenu) {
                await this.submit(commit, () => {   
                    item.EndTime = item.EndTimeEdit !== undefined ? item.EndTimeEdit : item.EndTime;
                }, item.BerriesHarvestPlanTeamID);
            }
        },
        startTimeStartEdit() {
            this.$nextTick(() => {
                this.showStartTimeMenu = true
            })
        },
        async startTimeMenuInput(commit, item) {
            if(!this.showStartTimeMenu) {
                await this.submit(commit, () => { 
                    this.updateTeamStartTime(item);
                }, item.BerriesHarvestPlanTeamID);
            }
        },
        selectTeamPieceRateEmail(e, item) {
            e.cancelBubble  = true;
            item.SendPieceRateAgreement = !item.SendPieceRateAgreement;
        },
        async showConfirmResendAgreementDialog(showDialog) {
            if(showDialog){
                //prompt user before sending
                this.showConfirmEmail = true;
            }
            else {
                //first time being sent
                await this.sendPieceRateAgreements()
            }
        },
        async confirmResendAgreements() {
            //user confirmed they want to resend agreements
            await this.sendPieceRateAgreements()
            this.showConfirmEmail = false;
        },
        async sendPieceRateAgreements() {
            this.confirmDialogLoading = true;
            await this.sendSelectedTeamsPieceRateAgreement();
            this.confirmDialogLoading = false;
        },
        dismissPiecerateNotification() {
            this.dismissPiecerateAgreementNotification();
        },
        expandAllPanels() {
            this.panel = this.getTeams.map(() => true);
        }
    },
    filters: {
        formatDateTimeToLocal: function (value) {
            if (value) {
                return moment(value).format("DD/MM/YYYY hh:mm A Z")
            }
            else {
                return "";
            }
        }
    }
}
</script>